import { useEffect, useState } from 'react';
import { getOnboardingLayoutType } from '../components/onboarding/onboardingConstants';

const DESKTOP_MQ = '(min-width: 1024px)';

export function useOnboardingLayout(): 'mobile' | 'desktop' {
  const [layout, setLayout] = useState<'mobile' | 'desktop'>(getOnboardingLayoutType);

  useEffect(() => {
    const mq = window.matchMedia(DESKTOP_MQ);
    const onChange = () => setLayout(mq.matches ? 'desktop' : 'mobile');
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return layout;
}
